import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import BasicInfo from './basicInfo';
import TopCollege from './topCollege';
import Prospects from './prospects';
import ProsCons from './prosCons';
import FamousPersonality from './famousPersonality';

const CareerDeepDive = () => {
  const { id } = useParams(); 
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("basic_details");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    if (tab) {
      setActiveTab(tab);
    }
  }, [location.search]);

  return (
    <div className="content container-fluid">
      <div className="page-header">
        <div className="row g-4 align-items-center">
          <div className="col">
            <h3 className="page-title">Career Deep Dive</h3>
          </div>

          <div className="col-12">
            <div className="custom-tab">
              <div className="x-scroll mb-4">
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "basic_details" ? "active" : ""}`}
                      id="pills-basic-details-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-basic-details"
                      type="button"
                      role="tab"
                      aria-controls="pills-basic-details"
                      aria-selected={activeTab === "basic_details"}
                      onClick={() => setActiveTab("basic_details")}
                    >
                      Basic Details
                    </button>
                  </li>
                  {id && (
                    <>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "top_college" ? "active" : ""}`}
                          id="pills-top-college-list-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-top-college-list"
                          type="button"
                          role="tab"
                          aria-controls="pills-top-college-list"
                          aria-selected={activeTab === "top_college"}
                          onClick={() => setActiveTab("top_college")}
                        >
                          Top College List
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "prospects" ? "active" : ""}`}
                          id="pills-career-prospect-list-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-career-prospect-list"
                          type="button"
                          role="tab"
                          aria-controls="pills-career-prospect-list"
                          aria-selected={activeTab === "prospects"}
                          onClick={() => setActiveTab("prospects")}
                        >
                          Career Prospect List
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "pros_cons" ? "active" : ""}`}
                          id="pills-pros-cons-list-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-pros-cons-list"
                          type="button"
                          role="tab"
                          aria-controls="pills-pros-cons-list"
                          aria-selected={activeTab === "pros_cons"}
                          onClick={() => setActiveTab("pros_cons")}
                        >
                          Pros and Cons List
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "famous_personality" ? "active" : ""}`}
                          id="pills-famous-personalities-list-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-famous-personalities-list"
                          type="button"
                          role="tab"
                          aria-controls="pills-famous-personalities-list"
                          aria-selected={activeTab === "famous_personality"}
                          onClick={() => setActiveTab("famous_personality")}
                        >
                          Famous Personalities List
                        </button>
                      </li>
                    </>
                  )}
                </ul>
              </div>

              <div className="tab-content" id="pills-tabContent">
                <div className={`tab-pane fade ${activeTab === "basic_details" ? "show active" : ""}`} id="pills-basic-details" role="tabpanel" aria-labelledby="pills-basic-details-tab" tabIndex="0">
                  <BasicInfo />
                </div>
                {id && (
                  <>
                    <div className={`tab-pane fade ${activeTab === "top_college" ? "show active" : ""}`} id="pills-top-college-list" role="tabpanel" aria-labelledby="pills-top-college-list-tab" tabIndex="0">
                      <TopCollege />
                    </div>
                    <div className={`tab-pane fade ${activeTab === "prospects" ? "show active" : ""}`} id="pills-career-prospect-list" role="tabpanel" aria-labelledby="pills-career-prospect-list-tab" tabIndex="0">
                      <Prospects />
                    </div>
                    <div className={`tab-pane fade ${activeTab === "pros_cons" ? "show active" : ""}`} id="pills-pros-cons-list" role="tabpanel" aria-labelledby="pills-pros-cons-list-tab" tabIndex="0">
                      <ProsCons />
                    </div>
                    <div className={`tab-pane fade ${activeTab === "famous_personality" ? "show active" : ""}`} id="pills-famous-personalities-list" role="tabpanel" aria-labelledby="pills-famous-personalities-list-tab" tabIndex="0">
                      <FamousPersonality />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareerDeepDive;
